export default __webpack_public_path__ + "static/media/ReferralSystemLeft.0d133d2b.png";